// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-8fb19184] .w-input-root {height: 100%;}\n*[data-v-8fb19184] .w-input-root > .w-textarea{\n\tpadding: 0 0 0 0; border: 0; font-family: monospace;\n\theight: 100%;}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
